// /src/components/GuestChat.js

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../api/axios';
import AIChat from './AIChat';
import { FaSpinner } from 'react-icons/fa';

const GuestChat = ({ setIsAuthenticated, setUserRole }) => {
  const { shortId } = useParams();
  const navigate = useNavigate();
  const [isValidToken, setIsValidToken] = useState(false);
  const [guestToken, setGuestToken] = useState(null);
  const [propertyInfo, setPropertyInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateAccess = async () => {
      try {
        console.log('Starting guest access validation for shortId:', shortId);
        
        const tokenResponse = await api.get(`/auth/guest-token/${shortId}`);
        const token = tokenResponse.data.guestToken;
        
        const validationResponse = await api.post('/auth/validate-guest-token', 
          { token }
        );

        if (validationResponse.data.isValid) {
          setGuestToken(token);
          setPropertyInfo({
            id: validationResponse.data.propertyId,
            name: validationResponse.data.propertyName,
            hostContact: validationResponse.data.hostContact || null
          });
          setIsValidToken(true);

          localStorage.setItem('guestToken', token);
          localStorage.setItem('role', 'guest');
          setIsAuthenticated(true);
          setUserRole('guest');
        }
      } catch (error) {
        console.error('Access validation failed:', error.response?.data || error.message);
        navigate('/login');
      } finally {
        setIsLoading(false);
      }
    };

    validateAccess();
  }, [shortId, navigate, setIsAuthenticated, setUserRole]);

  if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center h-screen bg-gray-900">
        <FaSpinner className="animate-spin text-white text-4xl mb-4" />
        <p className="text-white">Loading guest access...</p>
      </div>
    );
  }

  if (!isValidToken || !guestToken || !propertyInfo) {
    return null;
  }

  return (
    <AIChat
      isGuest={true}
      guestPropertyId={propertyInfo.id}
      guestToken={guestToken}
      guestPropertyName={propertyInfo.name}
      guestHostContact={propertyInfo.hostContact}
    />
  );
};

export default GuestChat;
